// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
/**
 * Component capable of rendering the `LegacyModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let LegacyModuleUi = class LegacyModuleUi extends AbstractModuleUi {
    /**
     * Determines whether there are any additional scripts to load.
     */
    get hasScripts() {
        const scripts = this.module.content.scripts;
        return typeof scripts !== 'undefined' && Array.isArray(scripts) && scripts.length > 0;
    }
    /**
     * Loads the module's scripts (if there are any).
     */
    loadScripts() {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }
        this.module.content.scripts.forEach(script => this.loadSingleScript(script));
    }
    /**
     * Loads single script.
     *
     * @param script - The script to load.
     */
    loadSingleScript(script) {
        const scriptEl = document.createElement('script');
        if (!Object.prototype.hasOwnProperty.call(script, 'src')) {
            console.error(`LegacyModuleUi.loadScripts(): Provided script does NOT have required [src] attribute! Aborting!\nFull [script] object: ${JSON.stringify(script)}.`);
        }
        if (typeof script.src !== 'string') {
            console.error(`LegacyModuleUi.loadScripts(): Expected [src] attribute to be a type of [string], but got [${typeof script.src}]! Aborting!\nFull [script] object: ${JSON.stringify(script)}.`);
        }
        Object.entries(script).forEach(([key, value]) => {
            scriptEl.setAttribute(key, value);
        });
        document.head.appendChild(scriptEl);
    }
};
LegacyModuleUi = __decorate([
    Component({
        name: 'LegacyModuleUi',
        created() {
            if (this.hasScripts) {
                this.loadScripts();
            }
        },
        template: `
    <section v-if="(module.content.html && module.content.html.length) || debug"
             v-html="module.content.html"
             class="legacy-module module" :class="debugClass"/>
    <section v-else class="empty-div"></section>
  `
    })
], LegacyModuleUi);
export { LegacyModuleUi };
